
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
name: "RepairLog",
components: {XHeader},
data() {
return {
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
logList: [],
seq: this.$route.params.seq,
role: this.$route.params.role,
type:this.$route.params.type
}
},
created() {
this.$http.get('/api/v1/normalrepairs/' + this.seq + '?role=' + this.role + '&type=logs', this.header).then(logs => {
this.logList = logs.data;
});
},
beforeRouteLeave(to, from, next) {
if (to.name === 'RepairSrvp') {
to.params.seq = this.seq;
to.params.type = this.type;
to.params.role = this.role;
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/repairs/RepairLog.vue